module.exports = __webpack_public_path__ + "static/media/caret.573683ff.svg";